import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/header/header.component';
import { LoadingComponent } from './shared/loading/loading.component';

import { Store, StoreModule } from '@ngrx/store';
import { loadingReducer } from './store/loading.actions';
import { delay, Observable } from 'rxjs';
import { aparece, desaparece } from './store/loading.reduce';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from './shared/paginator/custom-mat-paginator';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { authClinicInterceptor } from './interceptors/auth-clinic.interceptor';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
        // { provide: HTTP_INTERCEPTORS, useClass: authClinicInterceptor, multi: true },
    ]
})
export class AppComponent implements OnInit {
  title = 'Frontend-Migra';

  // loading$!: Observable<boolean>
  loading$!: boolean

  constructor(
    private store: Store<{ loading: boolean }>
  ){
    // console.log(store.subscribe(resp => console.log(resp, "respuesta")))

    // // this.loading$ = store.select('loading');
    // store.select('loading').subscribe(resp => this.loading$ = resp);
    //this.store.dispatch(apareceSpinner());
    // this.store.dispatch(desaparece());
    
  }
  ngOnInit(): void {
      // this.store.dispatch(desaparece());
    

  }
}

// 